globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Partials = appCustomerSpace.Modals.Partials || {};

appCustomerSpace.Modals.Partials.VariablePicker = (function(superClass) {

  utils.extend(VariablePicker, superClass);

  function VariablePicker($html) {
    this.$html = $html;
    return VariablePicker.__super__.constructor.apply(this, arguments);
  }

  function insertAtCursor(field, text) {
    var start = field.selectionStart;
    var end = field.selectionEnd;
    var value = field.value;
    field.value = value.slice(0, start) + text + value.slice(end);
    field.selectionStart = field.selectionEnd = start + text.length;
  }

  $.extend(VariablePicker.prototype, {
    init: function() {
      var modal = this;
      VariablePicker.__super__.init.apply(this, arguments);

      $('.modal-backdrop').last().remove();
      $('body').removeClass('modal-open');

      this.$html.find('.variable-picker-insert').each(function() {
        $(this).on('click', function(event) {
          event.preventDefault();
          var token = $(this).data('token');
          var selector = $(this).data('target-input');
          if (!token || !selector) return;

          var $input = $(selector);
          if (!$input.length) return;

          insertAtCursor($input[0], token);
          $input.trigger('input').focus();
        });
      });
    }
  });

  return VariablePicker;
})(appCustomerSpace.Modal);
